import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import { customerInvoiceItemsHeaders } from "@/constants/defaultHeader";
export default {
	state: {
		customerInvoiceItemsFilters: null,
		customerInvoiceItemsList: null,
		customerInvoiceItemsLimit: null,
		customerInvoiceItemsOrder: null,
		customerInvoiceItemsSort: null,
		customerInvoiceItemsTotal: null,
		customerInvoiceItemsTotals: null,
	},
	mutations: {
		updateCustomerInvoiceItemsList(state, { rows, limit, order, sort, total }) {
			state.customerInvoiceItemsList = rows;
			state.customerInvoiceItemsLimit = limit;
			state.customerInvoiceItemsOrder = order;
			state.customerInvoiceItemsSort = sort;
			state.customerInvoiceItemsTotal = total;
			state.customerInvoiceItemsTotals = { id: total, };
		},
		updateCustomerInvoiceItemsFilters(state, { filter }) {
			state.customerInvoiceItemsFilters = filter;
		},
	},
	actions: {
		async getCustomerInvoiceItems({ commit, dispatch }, filters) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/payments/list', filters);

				if (data) {
					commit('updateCustomerInvoiceItemsList', data);
					commit('updateSettings', {
						settings: data.settings,
						// settings: customerInvoiceItemsHeaders,
						key: requestKeys.CUSTOMER_INVOICE_ITEMS,
						defaultHeader: customerInvoiceItemsHeaders
					});
				}
			} catch (error) {
				console.error(error);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getCustomerInvoiceItemsFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/payments/filters', values);
				if (data) commit('updateCustomerInvoiceItemsFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async deleteCustomerInvoiceItems({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/payments/${ id }`);
				if (data && data.status) {
					dispatch('getCustomerInvoiceItems', {});
					dispatch('setAlert', { type: "success", message: "✅ The record has been successfully deleted." });
				}
			} catch (e) {
				console.error(e);
			}
		},

	},
	getters: {
		customerInvoiceItemsFilters: (s) => s.customerInvoiceItemsFilters,
		customerInvoiceItemsList: (s) => s.customerInvoiceItemsList,
		customerInvoiceItemsTotals: (s) => s.customerInvoiceItemsTotals,
		customerInvoiceItemsLimit: (s) => s.customerInvoiceItemsLimit,
		customerInvoiceItemsOrder: (s) => s.customerInvoiceItemsOrder,
		customerInvoiceItemsSort: (s) => s.customerInvoiceItemsSort,
		customerInvoiceItemsTotal: (s) => s.customerInvoiceItemsTotal,
	}
};
